<template>
    <div>
        <Menu/>
        <div class="banner">
            <b-container>
                <b-row>
                    <b-col md="8" offset-md="2">
                        <h3>Su satisfacción y confianza nos inspiran a seguir innovando y mejorando cada día.</h3>
                        <p>Nuestros aliados son el corazón de todo lo que hacemos. Creemos que cada aliado es parte de nuestra familia, y nos esforzamos por brindarles productos de calidad y un servicio excepcional. Su lealtad y apoyo nos motivan a alcanzar nuevas alturas y a continuar nuestra misión de iluminar miradas y proteger sueños. Gracias por ser parte esencial de nuestro viaje.</p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Slide/>
        <div class="elegir">
            <b-container>
                <b-row class="mb-5">
                    <b-col class="text-center" md="10" offset-md="1">
                        <span class="hightlight">Por qué elegir Ctrendy</span>
                        <h3 class="mb-3 mt-3">Elegir a Ctrendy como su aliado de lentes es optar por calidad, innovación y un compromiso inquebrantable con la excelencia. Con más de 35 años de experiencia, ofrecemos una amplia variedad de modelos que reflejan las últimas tendencias globales.</h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-3" md="4">
                        <div class="blue-square">
                            <div class="img-wrapper">
                                <img src="../assets/clientes/iconolentes.png" alt="icon">
                            </div>
                            <p class="strong">Variedad de modelos</p>
                            <p>Nuestro inventario cuenta con
                                la variedad de modelos más grande
                                del mercado, y este va cambiando
                                según la temporada, las tendencias
                                de la moda y estilo a nivel global.</p>
                        </div>
                    </b-col>
                    <b-col class="mb-3" md="4">
                        <div class="blue-square">
                            <div class="img-wrapper">
                                <img src="../assets/clientes/iconocaja.png" alt="icon">
                            </div>
                            <p class="strong">Distribución</p>
                            <p>A través de nuestras 32 ubicaciones distribuidas forma estratégica por
                                todo México, podemos atender a todas las ciudades dentro del país.</p>
                        </div>
                    </b-col>
                    <b-col class="mb-3" md="4">
                        <div class="blue-square">
                            <div class="img-wrapper">
                                <img src="../assets/clientes/iconolista.png" alt="icon">
                            </div>
                            <p class="strong">Practicidad</p>
                            <p>Nuestra experiencia nos ha llevado a completar un método de trabajo único y funcional. Un producto complejo de comercializar se ha vuelto sencillo para nuestros clientes. Lo único que tiene que hacer es permitir que se exhiba y el resto lo hace Ctrendy.</p>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="clientes">
            <img src="../assets/clientes/circles3.svg" class="img-circles" alt="">
            <b-container>
                <b-row>
                    <b-col class="text-center" md="5">
                        <span class="hightlight-light">¿Cómo ser un cliente?</span>
                        <h3 class="mb-3 mt-3">Cliente Ctrendy</h3>
                    </b-col>
                    <b-col md="7">
                        <p>Nuestro mercado objetivo se conforma principalmente por: tiendas de conveniencia | autoservicio | farmacias</p>
                        <ul>
                            <li>Proporcionamos exhibidor: Está comprobado que nuestros exhibidores son la opción más efectiva para impulsar las ventas del producto.</li>
                        </ul>
                        <p>Trabajamos con un enfoque denominado 'Servicio Total', que incluye:</p>
                        <ul>
                            <li>Más de mil modelos de gafas,</li>
                            <li>Mantenimiento y limpieza tanto del exhibidor como del producto,</li>
                            <li>Y la rotación de modelos con baja demanda</li>
                            <li>Nuestros promotores ofrecen una asesoría personalizada según las necesidades de la tienda, para potencializar la venta. </li>
                        </ul>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="mostrador">
            <b-container>
                <b-row>
                    <b-col md="6" class="align-self-center">
                        <img class="img-fluid" src="../assets/clientes/mostrador.png" alt="glasses">                        
                    </b-col>
                    <b-col md="6" class="align-self-center">
                        <b-button class="btn-call">Llamado a la acción</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="befashion">
            <b-container>
                <b-row>
                    <b-col md="12">
                        <span class="hightlight">¿Por qué Ctrendy?</span>
                        <h3 class="mb-3 mt-3">Nuestra capacidad<br> de negocio</h3>
                    </b-col>
                    <b-col class="linkstext"  md="5">
                        <p :class="{active: this.index==0}" v-on:click="selectedText(0)">Experiencia <img v-if="this.index!=0" src="../assets/clientes/Vector.png" alt="vector arrow"><img v-else src="../assets/clientes/VectorActive.png" alt="vector arrow"></p>
                        <p :class="{active: this.index==1}" v-on:click="selectedText(1)">Innovación <img v-if="this.index!=1" src="../assets/clientes/Vector.png" alt="vector arrow"><img v-else src="../assets/clientes/VectorActive.png" alt="vector arrow"></p>
                        <p :class="{active: this.index==2}" v-on:click="selectedText(2)">Cobertura y distribución <img v-if="this.index!=2" src="../assets/clientes/Vector.png" alt="vector arrow"><img v-else src="../assets/clientes/VectorActive.png" alt="vector arrow"></p>
                        <p :class="{active: this.index==3}" v-on:click="selectedText(3)">Atención y servicio <img v-if="this.index!=3" src="../assets/clientes/Vector.png" alt="vector arrow"><img v-else src="../assets/clientes/VectorActive.png" alt="vector arrow"></p>
                        <p :class="{active: this.index==4}" v-on:click="selectedText(4)">Garantía <img v-if="this.index!=4" src="../assets/clientes/Vector.png" alt="vector arrow"><img v-else src="../assets/clientes/VectorActive.png" alt="vector arrow"></p>
                    </b-col>
                    <b-col  md="7">
                        <p v-html="text"></p>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <div class="form text-center">
            <b-container>
                <b-row>
                    <b-col>
                        <span class="hightlight">Envíanos un mensaje</span>
                        <div class="mt-4 form-wrapper">
                            <h3 class="mb-5">Forma parte de nuestra<br> red de aliados</h3>
                            <p class="sendText">{{ messageSend }}</p>
                            <b-container>
                                <b-row>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-1" v-model="c_name" placeholder="Name*" type="text"></b-form-input>
                                        <label for="input-1">Nombre</label>
                                    </b-col>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-2" v-model="c_email" placeholder="Email*" type="text"></b-form-input>
                                        <label for="input-2">Correo electrónico</label>
                                    </b-col>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-3" v-model="c_phone" placeholder="Phone*" type="text"></b-form-input>
                                        <label for="input-3">Número de teléfono</label>
                                    </b-col>
                                    <b-col md="6" class="mb-3 form-floating">
                                        <b-form-input id="input-2" v-model="c_company" placeholder="Empresa*" type="text"></b-form-input>
                                        <label for="input-2">Empresa</label>
                                    </b-col>
                                    <b-col md="12" class="mb-3"> 
                                        <b-form-textarea id="input-3" v-model="c_message" placeholder="Mensaje" rows="6" max-rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </b-container>
                            
                            <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                            <b-button class="btn btn-clients mt-4" v-on:click="sendMessage">Enviar mensaje</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Menu from '../components/Menu.vue'
    import Footer from '../components/Footer.vue'
    import Slide from '../components/SlideBrands.vue'
    import axios from 'axios'
    export default {
        name: 'Clients',
        components: {
            Menu,
            Slide,
            Footer
        },
        data() {
            return {
                c_name: '',
                c_email: '',
                c_phone: '',
                c_company: '',
                c_message: '',
                pet:'',
                messageSend: '',
                index: '8',
                text: '',
                arrayText: [
                    'Más de 30 años de experiencia en la comercialización de lentes de sol y lectura. Conocemos el mercado nacional e internacional de inicio a fin.<br><br> Contáctanos hoy mismo para convertirte en uno de nuestros aliados de negocio.',
                    'Las nuevas prácticas, métodos y mantener nuestra gama de productos actualizados son vitales en la industria de la moda. Estamos siempre a la vanguardia.<br><br> Contáctanos hoy mismo para convertirte en uno de nuestros aliados de negocio.',
                    'Estamos en todo México, bajo nuestra red de distribución y logística bien afianzada, para surtir a tiempo a todos nuestros aliados de negocio.<br><br>Contáctanos hoy mismo para convertirte en uno de nuestros aliados de negocio.',
                    'Nuestra filosofía ha sido siempre brindar atención y seguimiento a nuestros clientes y aliados de negocio, sabemos que una buena comunicación creará relaciones a más largo plazo.<br><br>Contáctanos hoy mismo para convertirte en uno de nuestros aliados de negocio.',
                    'Nuestros productos son de alta calidad, para una satisfacción máxima del consumidor. Además empaquetamos con gran seguridad cada pedido de nuestros clientes, con el objetivo de garantizar la integridad de nuestros productos.<br><br>Contáctanos hoy mismo para convertirte en uno de nuestros aliados de negocio.',
                ]
            }
        },
        methods: {
            selectedText(index){
                this.index = index
                this.text = this.arrayText[index]
            },
            sendMessage: async function(){
                var responseData
                if(this.c_name != '' && this.c_email != '' && this.pet == ''){
                    await axios.post('vendor/send-client.php', {
                        name: this.c_name,
                        email: this.c_email,
                        phone: this.c_phone,
                        company: this.c_company,
                        message: this.c_message
                    })
                    .then((response) => {
                        responseData = response.data
                    })
                    .catch((error) => {
                        /* eslint-disable no-console */
                        console.log(error);
                        /* eslint-enable no-console */
                    });
                    console.log(responseData);
                    if(responseData==200 || responseData=='200') {
                        this.c_name = ''
                        this.c_email = ''
                        this.c_phone =  ''
                        this.c_company = ''
                        this.c_message = ''
                        this.messageSend = 'Mensaje enviado'
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
                    }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.'
                }
            }
        }
    }
</script>

<style scoped>
h3{
  font-size: 35px;
  font-weight: 400;
}
p, ul{
    font-size: 20px;
}


/* BANNER */
.banner{
    padding-top: 250px;
    padding-bottom: 95px;
    text-align: center;
    background: #16B7C240;
}

.elegir{
    padding: 100px 0;
}

.blue-square{
    background: #16B7C266;
    border-radius: 10px;
    padding: 40px 30px 30px 30px;
    height: 100%;
}
.img-wrapper{
    height: 90px;
}
.blue-square p{
    font-size: 16px;
}
.blue-square .strong{
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 0;
}

/* CLIENTES */
.clientes{
    padding: 140px 0 100px 0;
    background: #001824;
    color: #fff;
    text-align: justify;
    position: relative;
}
.img-circles{
    position: absolute;
    bottom: 0;
    left: 100px;
}

/* MOSTRADOR */
.mostrador{
    display: none;
    padding: 90px 5%;
}
.btn-call{
    background: #02FFF5 !important;
    border: none;
    border-radius: 0;
    color: #000 !important;
    padding: 15px 35px;
}

/*  */
.befashion{
    padding-top: 90px;
}

.linkstext p{
    display: block;
    text-decoration: none;
    width: 100%;
    border-bottom: 1px solid #8A8A8A;
    color: #8A8A8A;
    font-size: 25px;
    padding: 25px 40px 15px 15px;
    position: relative;
}

.linkstext p.active{
    border-bottom: 1px solid #386CE7;
    color: #386CE7;
}

.linkstext p:hover{
    cursor: pointer;
}

.linkstext p img{
    position: absolute;
    right: 20px;
    bottom: 25px;
}

/* FORM */
.form{
    max-width: 1043px;
    margin-left: auto;
    margin-right: auto; 
    padding: 200px 0;
}
.form-wrapper{
    background: #16B7C2;
    border-radius: 20px;
    padding: 65px 100px;
}
/* FORM */
.btn-clients{
    width: 100%; 
    color: #fff !important;
    font-size: 25px;
    background: #001824 !important;
    border: none;
    padding: 10px;
    max-width: 285px;
}

.form-floating > .form-control{
    background: #fff;
    border: none;
    border-radius: 5px;
    color: #000;
    font-size: 18px;
    outline: none !important;
    padding-left: 20px;
}

.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(0,0,0, 0.4) !important; 
    -webkit-transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    transform: scale(0.65) translateY(-0.5rem) translateX(0rem);
    left: 20px;
}

label{
    color: #000;
    font-size: 18px;
}
textarea{
    background: #fff;
    border-radius: 5px;
    border: none;
    outline: none;
    font-size: 18px;
    color: #000;
    padding-left: 20px;
}
input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 18px;
    color: #000 !important;
    padding-left: 20px;
    left: 10px;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #000 !important;
}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
.sendText{
    font-size: 16px;
    font-weight: 700;
}
@media (max-width: 768px){
    h3{
        font-size: 27px;
        line-height: 1;
        font-weight: 400;
    }
    p, ul{
        font-size: 18px;
        line-height: 20px;
    }


    /* BANNER */
    .banner{
        padding-top: 150px;
        padding-left: 7%;
        padding-right: 7%;
    }
    .elegir{
        padding: 100px 7%;
    }

    
    /* CLIENTES */
    .clientes{
        padding: 80px 7% 60px 7%;
        background: #386CE7;
        color: #fff;
        text-align: justify;
        position: relative;
    }
    .img-circles{
        display: none;
    }

    /* MOSTRADOR */
    .mostrador{
        padding: 90px 7%;
    }
    .btn-call{
        background: #02FFF5 !important;
        border: none;
        border-radius: 0;
        color: #000 !important;
        margin-top: 30px;
        padding: 15px 35px;
    }

    /*  */
    .befashion{
        padding: 0 7%;
    }
    .linkstext p{
        font-size: 20px;
    }

    .linkstext p.active{
        border-bottom: 1px solid #386CE7;
        color: #386CE7;
    }

    .linkstext p:hover{
        cursor: pointer;
    }

    .linkstext p img{
        position: absolute;
        right: 20px;
        width: 15px;
        bottom: 20px;
    }
    /* FORM */
    .form{
        max-width: 1043px;
        margin-left: auto;
        margin-right: auto; 
        padding: 100px 0;
    }
    .form-wrapper{
        padding: 65px 7%;
    }
    .btn-clients{
        font-size: 20px;
    }
}

</style>